import React from "react";
import { Spinner } from "@chakra-ui/react";
import { Drawer } from "../../Components/Organisms";
import "./styles.css";

const Loader = ({ hide }) => {
  return (
    <main className="panel-body">
      {hide ? null : <Drawer />}
      <Spinner className="panel-spinner" size="xl" />

      <div className="panel-overlay panel-blur" />
    </main>
  );
};

export default Loader;
